import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const toSelectOptions = (itens) =>
  (itens || []).map((item) => ({
    value: item.codigo,
    label: item.descricao,
  }));

const findOption = (opcoes, value) =>
  toSelectOptions(opcoes).find((option) => option.value === value) || null;

const renderError = (errors, touched, field) =>
  touched[field] && errors[field] ? (
    <div className="text-danger small mt-1">{errors[field]}</div>
  ) : null;

const PainelFiltros = ({
  values,
  errors,
  touched,
  setFieldValue,
  opcoes,
  isSubmitting,
  loadingContas = false,
  onGrupoEmpresaChange,
}) => (
  <Card className="mb-3 shadow-sm">
    <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
      <strong>Filtros</strong>
    </Card.Header>
    <Card.Body>
      <Row>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Data Inicial *</Form.Label>
            <Form.Control
              type="date"
              value={values.dataInicio || ''}
              onChange={(e) => setFieldValue('dataInicio', e.target.value)}
              isInvalid={touched.dataInicio && !!errors.dataInicio}
              disabled={isSubmitting}
            />
            {renderError(errors, touched, 'dataInicio')}
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Data Final *</Form.Label>
            <Form.Control
              type="date"
              value={values.dataFim || ''}
              onChange={(e) => setFieldValue('dataFim', e.target.value)}
              isInvalid={touched.dataFim && !!errors.dataFim}
              disabled={isSubmitting}
            />
            {renderError(errors, touched, 'dataFim')}
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Grupo de Empresa</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.grupos_empresa)}
              value={findOption(opcoes.grupos_empresa, values.grupoEmpresaId)}
              onChange={(option) => {
                const novoValor = option ? option.value : null;
                setFieldValue('grupoEmpresaId', novoValor);
                // G-SEL-01: lock mútuo com Grupo GE (paridade Delphi LgeChange:600)
                if (novoValor != null) setFieldValue('grupoGeId', null);
                if (onGrupoEmpresaChange) onGrupoEmpresaChange(novoValor);
              }}
              isClearable
              isDisabled={isSubmitting || values.grupoGeId != null}
              placeholder="Selecione..."
              noOptionsMessage={() => 'Nenhum GE encontrado'}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          {/* G-SEL-01: combo Lgrupo (Grupo GE) — paridade URelDespesasAnalitico.dfm:574-588 */}
          <Form.Group>
            <Form.Label>Grupo de GE</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.grupos_ge)}
              value={findOption(opcoes.grupos_ge, values.grupoGeId)}
              onChange={(option) => {
                const novoValor = option ? option.value : null;
                setFieldValue('grupoGeId', novoValor);
                // G-SEL-01: lock mútuo com GE (paridade Delphi LgrupoChange:633)
                if (novoValor != null) {
                  setFieldValue('grupoEmpresaId', null);
                  if (onGrupoEmpresaChange) onGrupoEmpresaChange(null);
                }
              }}
              isClearable
              isDisabled={isSubmitting || values.grupoEmpresaId != null}
              placeholder="Selecione..."
              noOptionsMessage={() => 'Nenhum Grupo de GE encontrado'}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Moeda</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.moedas)}
              value={findOption(opcoes.moedas, values.moedaFiltroId)}
              onChange={(option) =>
                setFieldValue('moedaFiltroId', option ? option.value : null)
              }
              isClearable
              isDisabled={isSubmitting}
              placeholder="Selecione..."
              noOptionsMessage={() => 'Nenhuma moeda encontrada'}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Valor Mínimo</Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="0.01"
              value={values.valorMinimo}
              onChange={(e) => setFieldValue('valorMinimo', e.target.value)}
              isInvalid={touched.valorMinimo && !!errors.valorMinimo}
              disabled={isSubmitting}
            />
            {renderError(errors, touched, 'valorMinimo')}
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Centro de Custo</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.centros_custo)}
              value={findOption(opcoes.centros_custo, values.centroCustoId)}
              onChange={(option) => {
                // GAP-09: lock CC ↔ Depto (paridade Delphi RxDepartamentoChange:691-712)
                setFieldValue('centroCustoId', option ? option.value : null);
                if (option) setFieldValue('departamentoId', null);
              }}
              isClearable
              isDisabled={isSubmitting || values.departamentoId != null}
              placeholder="Selecione..."
              noOptionsMessage={() => 'Nenhum centro de custo encontrado'}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Departamento</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.departamentos)}
              value={findOption(opcoes.departamentos, values.departamentoId)}
              onChange={(option) => {
                // GAP-09: lock CC ↔ Depto
                setFieldValue('departamentoId', option ? option.value : null);
                if (option) setFieldValue('centroCustoId', null);
              }}
              isClearable
              isDisabled={isSubmitting || values.centroCustoId != null}
              placeholder="Selecione..."
              noOptionsMessage={() => 'Nenhum departamento encontrado'}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Conta</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.contas)}
              value={findOption(opcoes.contas, values.contaId)}
              onChange={(option) =>
                setFieldValue('contaId', option ? option.value : null)
              }
              isClearable
              isDisabled={isSubmitting || !values.grupoEmpresaId}
              isLoading={loadingContas}
              placeholder={values.grupoEmpresaId ? 'Selecione...' : 'Selecione um GE primeiro'}
              noOptionsMessage={() =>
                values.grupoEmpresaId ? 'Nenhuma conta encontrada' : 'Selecione um GE primeiro'
              }
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col xs={12} md={3}>
          <Form.Group>
            <Form.Label>Aprovador</Form.Label>
            <Select
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={toSelectOptions(opcoes.aprovadores)}
              value={findOption(opcoes.aprovadores, values.aprovadorId)}
              onChange={(option) =>
                setFieldValue('aprovadorId', option ? option.value : null)
              }
              isClearable
              isDisabled={isSubmitting}
              placeholder="Selecione..."
              noOptionsMessage={() => 'Nenhum aprovador encontrado'}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={9}>
          <Form.Label>Opções</Form.Label>
          <div className="d-flex flex-wrap align-items-center" style={{ gap: '16px' }}>
            <Form.Check
              id="ocultar-contas-parametrizadas"
              type="checkbox"
              label="Ocultar Contas Parametrizadas"
              checked={!!values.ocultarContasParametrizadas}
              onChange={(e) =>
                setFieldValue('ocultarContasParametrizadas', e.target.checked)
              }
              disabled={isSubmitting}
            />
            <Form.Check
              id="sem-aprovacao"
              type="checkbox"
              label="Sem Aprovação"
              checked={!!values.apenasNaoAprovados}
              onChange={(e) =>
                setFieldValue('apenasNaoAprovados', e.target.checked)
              }
              disabled={isSubmitting}
            />
            <Form.Check
              id="ocultar-contas-bancos"
              type="checkbox"
              label="Filtrar Ocultando Bancos"
              checked={!!values.ocultarContasBancos}
              onChange={(e) =>
                setFieldValue('ocultarContasBancos', e.target.checked)
              }
              disabled={isSubmitting}
            />
            <Form.Check
              id="contas-internas"
              type="checkbox"
              label="Contas Internas"
              checked={!!values.incluirContasInternas}
              onChange={(e) =>
                setFieldValue('incluirContasInternas', e.target.checked)
              }
              disabled={isSubmitting}
            />
            <Form.Check
              id="ordenar-por-aprovador"
              type="checkbox"
              label="Ordenar por Aprovador"
              checked={!!values.ordenarPorAprovador}
              onChange={(e) =>
                setFieldValue('ordenarPorAprovador', e.target.checked)
              }
              disabled={isSubmitting}
            />
          </div>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default PainelFiltros;
